
  import { Component, Mixins, Prop } from "vue-property-decorator";
  import { ErrorBag, Field } from "vee-validate";
  import { ChangePasswordDto } from "@/views/base/base.types";
  import BaseMixin from "@/views/base/base.mixin";
  
  @Component
  export default class ChangePasswordComponent extends Mixins(BaseMixin) {
    @Prop() changePasswordShow!: boolean;

    changePasswordDto: ChangePasswordDto = new ChangePasswordDto();
    loading = false;
    success = false;
    passwordShow = false;

    veeFields!: Field;
    veeErrors!: ErrorBag;

    async mounted()  {
      this.$store.commit("Base/updateField", {
        path: "errorMessage",
        value: null
      });
    }

    validateState(ref: keyof Field) {
      if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || 
          this.veeFields[ref].validated)
      ) {
          return !this.veeErrors.has(ref);
      }
      return null;
    }

    viewPassword() {
      this.passwordShow = !this.passwordShow;
    }

    changePassword() {
      this.$validator.validateAll().then(async (isValid: boolean) => {
        if (isValid) {
          this.loading = true;
          await this.$store.dispatch("Base/changePassword", {
            username: this.user.username,
            currentPassword: this.changePasswordDto.currentPassword,
            newPassword: this.changePasswordDto.newPassword
          });
          this.loading = false;
          this.success = !this.errorMessage;
        }
      });
    }
  
    closeModal() {
      this.$emit('update:changePasswordShow', false);
    }
  }
  